export const tooltips = {
	// General Info tooltips
	sku:
		"Le SKU (Stock Keeping Unit) est un code unique pour identifier le produit. Si vous ne le remplissez pas, nous en générerons un automatiquement.",
	preparationTime: "Saisissez le temps nécessaire à la cuisine pour préparer ce produit",
	hasAlcohol:
		"Lorsqu'il est activé, il apparaîtra sur le menu des clients qu'il contient de l'alcool",

	// Stock tooltips
	isStockable:
		"Les produits stockables sont ceux qui sont conservés en stock jusqu'à ce qu'ils soient vendus ou utilisés.",
	conversionRule:
		"Définissez comment les unités de vente se convertissent en unités de stock. Ex: 1 bouteille = 1 litre",

	// Fiscal Data tooltips
	ncm: "Nomenclature Commune du Mercosur",
	cest: "Code Spécificateur de Substitution Fiscale",
	fiscalProfile:
		"Ensemble de données qui décrit la situation fiscale d'une personne ou d'une entreprise.",
	fiscalGroup:
		"Le groupe fiscal est un code qui classe les produits selon leur imposition.",

	// Pricing tooltips
	variablePrice: "Prix variable: le prix du produit sera défini au point de vente",
};
